import { Injectable } from '@angular/core';
declare var window;

@Injectable({
  providedIn: 'root'
})
export class HomeIntroService {
  public alreadyDiplayed = false;

  constructor() { }

  displayHomeIntro(): boolean {
    // determine if there is an anchor link
    const path = window.location.pathname !== '/';
    if (path && !this.alreadyDiplayed) {
      this.alreadyDiplayed = true;
    }

    return !path && !this.alreadyDiplayed;
  }
}
